import { Modal, Box, Typography, Button } from "@mui/material";
import { ReactNode } from "react";

interface ModalProps {
  open: boolean;
  handleClose: () => void;
  title: string;
  children: ReactNode;
}

export function MyModal({ open, handleClose, title, children }: ModalProps) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minWidth: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    textAlign: "center",
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography variant="h5" component="h2">
          {title}
        </Typography>
        <Button
          sx={{ position: "absolute", right: "10px", top: "10px" }}
          onClick={handleClose}
        >
          X
        </Button>
        <Box sx={{ mt: 3 }}>{children}</Box>
      </Box>
    </Modal>
  );
}
